export async function LoadReceiptsData(searchString, userID) {
  let dataSource = [];
  let taskAmount = 0;

  const SearchString = searchString;

  const newDataSource = (SearchString) => {
    let string = SearchString;
    if (string === "") {
      string = "EMPTY_SEARCH_STRING";
    }
    const url = `/returnReceipts/${string}/${userID}`;
    return fetch(url)
      .then((response) => response.json())
      .then((data) => {
        taskAmount = data.length;
        return { data, count: data.length };
      });
  };
  dataSource = newDataSource(SearchString);

  //----------//

  let returnValues = {
    data: dataSource,
    count: taskAmount,
  };

  return returnValues;
}
